import { default as ApprovedSearch } from './ApprovedSearch';

export default ApprovedSearch;
